import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Disable browser's automatic scroll restoration
  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  // Use useLayoutEffect for immediate scroll before paint
  useLayoutEffect(() => {
    // Force scroll to top with multiple approaches for cross-browser compatibility
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    
    // Execute immediately
    scrollToTop();
    
    // Also execute after a tiny delay to handle async renders
    requestAnimationFrame(scrollToTop);
    setTimeout(scrollToTop, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
